import { fetchRequest } from "../Fetcher";
import { pollJobUntilDone } from "./PollJobUntilDone";

export const runStoryboardJob = async ({ body }) => {
  const { result } = await fetchRequest({
    method: "POST",
    path: `sessions/storyboards/generate`,
    data: JSON.stringify(body),
  });

  const job = result?.data ?? result;

  const storyboardId = job?.storyboard_id;

  if (!storyboardId) {
    throw new Error("Storyboard job not created");
  }

  await pollJobUntilDone({
    getStatus: () =>
      fetchRequest({
        method: "GET",
        path: `sessions/storyboards/${storyboardId}/status`,
      }),
  });

  const { result: storyboard } = await fetchRequest({
    method: "GET",
    path: `sessions/storyboards/${storyboardId}`,
  });

  return storyboard?.data ?? storyboard;
};